

















































































import _ from "lodash";
import Modal from "../core/Modals/Modal.vue";
import { MaterielApi } from "../api/MaterielApi";

const TITRES = {
    total: {
        titre: "📦 Tous les équipements",
        sousTitre: "Liste complète du parc en service.",
    },
    available: {
        titre: "✓ Équipements disponibles",
        sousTitre: "Matériel actuellement au dépôt, prêt à être sorti.",
    },
    out: {
        titre: "↗ Équipements actuellement dehors",
        sousTitre:
            "Matériel sorti et pas encore rentré, du plus ancien au plus récent.",
    },
};

export default {
    name: "EquipementsListModal",
    components: { Modal },
    props: {
        showModal: Boolean,
        // "total" | "available" | "out"
        mode: {
            type: String,
            default: "total",
        },
    },
    data() {
        return {
            MaterielApi: new MaterielApi(),
            equipements: [],
            loading: false,
            search: "",
            catFilter: "",
        };
    },
    computed: {
        titre: function () {
            return TITRES[this.mode] ? TITRES[this.mode].titre : "";
        },
        sousTitre: function () {
            return TITRES[this.mode] ? TITRES[this.mode].sousTitre : "";
        },
        categories: function () {
            return _.sortBy(
                _.uniq(
                    _.compact(
                        _.map(this.equipements, function (eq) {
                            return eq.categorie_nom;
                        })
                    )
                )
            );
        },
        items: function () {
            let self = this;
            let list = self.equipements.slice();

            if (self.catFilter) {
                list = _.filter(list, function (eq) {
                    return eq.categorie_nom === self.catFilter;
                });
            }

            if (self.search) {
                let q = self.search.toLowerCase();
                list = _.filter(list, function (eq) {
                    let haystack =
                        eq.libelle +
                        " " +
                        (eq.modele || "") +
                        " " +
                        (eq.emplacement_nom || "");
                    return haystack.toLowerCase().indexOf(q) !== -1;
                });
            }

            if (self.mode === "out") {
                // Du plus ancien au plus récent (date + heure du mouvement).
                list = list.sort(function (a, b) {
                    return self.cleTri(a).localeCompare(self.cleTri(b));
                });
            } else {
                list = list.sort(function (a, b) {
                    return self.cleCategorie(a).localeCompare(
                        self.cleCategorie(b)
                    );
                });
            }

            return list;
        },
    },
    methods: {
        load: function () {
            let self = this;
            let params = {};

            if (self.mode === "available") {
                params = { statut: "disponible" };
            } else if (self.mode === "out") {
                params = { statut: "sorti" };
            }

            self.loading = true;
            self.MaterielApi.getEquipements(params)
                .then(function (res) {
                    self.equipements = res;
                    self.loading = false;
                })
                .catch(function (error) {
                    self.loading = false;
                    self.$emit("toast", {
                        message: self.errorMessage(error),
                        kind: "error",
                    });
                });
        },
        cleTri: function (eq) {
            let mouvement = eq.dernier_mouvement;
            if (!mouvement) {
                return "";
            }
            return (
                (mouvement.date_mouvement || "") +
                (mouvement.heure_mouvement || "")
            );
        },
        cleCategorie: function (eq) {
            return (
                (eq.categorie_nom || "") +
                _.padStart(String(eq.numero || 0), 4, "0")
            );
        },
        dureeClass: function (jours) {
            return jours > 14 ? "danger" : jours > 7 ? "warn" : "ok";
        },
        dureeLabel: function (jours) {
            if (jours === 0) {
                return "Aujourd'hui";
            }
            if (jours === 1) {
                return "Hier";
            }
            return "Depuis " + jours + " jours";
        },
        errorMessage: function (error) {
            return _.get(
                error,
                "response.data.message",
                "Une erreur est survenue"
            );
        },
        close: function () {
            this.$emit("close-modal");
        },
    },
    watch: {
        showModal: {
            immediate: true,
            handler: function (value) {
                if (value) {
                    this.search = "";
                    this.catFilter = "";
                    this.load();
                }
            },
        },
        mode: function () {
            if (this.showModal) {
                this.search = "";
                this.catFilter = "";
                this.load();
            }
        },
    },
};
